<template>
  <div class="leak-event-graph">
    <highcharts
      class="chart"
      :options="chartOptions"
    />
  </div>
</template>

<script>
import leadDetailMixin from '@shared/mixins/leadDetailMixin';
import makeLeakGraphData from '../../../lib/lead/makeLeakGraphData';

export default {
  name: 'LeakLineHistoryGraph',
  mixins: [leadDetailMixin],
  computed: {
    graphData() {
      if (!this.activeAlertList || this.activeAlertList.length === 0) {
        return [];
      }
      const {
        graphData,
      } = this.activeAlertList[0];
      return makeLeakGraphData(graphData);
    },
    chartOptions() {
      return {
        title: {
          text: 'Past Five Days',
          style: {
            fontSize: 10,
            fontWeight: 500,
            fontFamily: 'Gilroy, sans-serif',
          },
        },
        chart: {
          type: 'line',
          height: 150,
          spacingBottom: 15,
          spacingLeft: 10,
          spacingRight: 10,
          spacingTop: 15,
          animation: false,
        },
        credits: {
          enabled: false,
        },
        yAxis: {
          gridLineWidth: 0,
          labels: {
            style: {
              fontSize: 10,
            },
            formatter() {
              if (this.value === 0) {
                return 'No Leak';
              }
              if (this.value > 0) { return 'Leak'; }
              return '';
            },
          },
          title: {
            text: false,
          },
        },
        xAxis: [{
          lineWidth: 0,
          tickInterval: 6,
          tickPositions: [5, 11, 17, 23, 29, 35, 41, 47, 53, 59, 65, 71, 77, 83, 89, 95, 101, 107, 113, 119],
          categories: this.graphData.map((data) => data.x),
          labels: {
            style: {
              fontSize: 8,
              fontWeight: 'bold',
              fontFamily: 'Gilroy, sans-serif',
            },
            formatter() {
              if (this.value < 13) {
                return `${this.value}AM`;
              }
              return `${this.value - 12}PM`;
            },
          },
        }, {
          lineWidth: 0,
          categories: this.graphData.map((data) => data.x2),
          tickInterval: 24,
          tickPositions: [0, 24, 48, 72, 96, 120],
          linkedTo: 0,
          labels: {
            style: {
              fontSize: 8,
              fontWeight: 'bold',
              fontFamily: 'Gilroy, sans-serif',
            },
          },
        }],
        legend: {
          layout: 'vertical',
          align: 'left',
          verticalAlign: 'middle',
          itemStyle: {
            fontSize: 8,
          },
        },
        plotOptions: {
          series: {
            enableMouseTracking: false,
            label: {
              connectorAllowed: true,
            },
            connectNulls: true,
            animation: {
              duration: 0,
            },
            lineWidth: 3,
            marker: {
              radius: 0,
            },
          },
        },
        series: [{
          showInLegend: false,
          name: '',
          color: '#4979FF',
          data: this.graphData.map((data) => data.y),
          step: 'right',
        }],
        responsive: {
          rules: [{
            condition: {
              maxWidth: 2000,
            },
          }],
        },
      };
    },
  },
};
</script>

<style lang="scss">
.leak-event-graph {
  border: 1px solid #EDF2FF;
  border-radius: 16px;
  margin: 20px 0;
  position: relative;
  width: 100%;
}
</style>
